import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {routerInstance} from '@aofl/router';
import {pages} from '../constants-enumerate';

/**
 * @summary BackButton
 * @class BackButton
 * @extends {AoflElement}
 */
@customElement('back-button')
class BackButton extends AoflElement {
  /**
   * Creates an instance of BackButton.
   */
  constructor() {
    super();
    this.urlSearchParams = new URLSearchParams(window.location.search);
  }

  /**
   * @readonly
   */
  static is = 'back-button';

  /**
   *
   * @param {Event} e
   */
  goBack(e) {
    if (this.urlSearchParams.get('to')) {
      routerInstance.navigate(pages.HOME, {});
    }
    window.history.back();
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default BackButton;
